import React from 'react';
import { CheckCircle2Icon, Loader2Icon, UploadCloudIcon } from 'lucide-react';
import { formatCurrency } from '../data/reports';
type PushBarProps = {
  count: number;
  totalBalance: number;
  totalMonthly: number;
  isPushing: boolean;
  onPush: () => void;
};
export function PushBar({
  count,
  totalBalance,
  totalMonthly,
  isPushing,
  onPush
}: PushBarProps) {
  const hasPending = count > 0;
  return <div className="sticky bottom-0 z-10 border-t border-ink-100 bg-white/95 shadow-[0_-1px_2px_rgba(24,24,24,0.04)] backdrop-blur" data-id="element-67" data-mp="vjp4bqr7v46c">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-3 px-6 py-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-68" data-mp="zipigvyr1in0">
        {hasPending ? <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm" data-id="element-69" data-mp="19j8681tfpja7">
            <span className="font-semibold text-ink-900" data-id="element-70" data-mp="36b8ejeeqb5qh">
              {count} {count === 1 ? 'liability' : 'liabilities'} ready to push
            </span>
            <span className="hidden h-4 w-px bg-ink-100 sm:block" data-id="element-71" data-mp="3bal9kmfr7j45" />
            <span className="text-ink-500" data-id="element-72" data-mp="15ljr7jw6hh3n">
              Balance{' '}
              <span className="font-medium tabular-nums text-ink-900" data-id="element-73" data-mp="10utokef4zscn">
                {formatCurrency(totalBalance)}
              </span>
            </span>
            <span className="hidden h-4 w-px bg-ink-100 sm:block" data-id="element-74" data-mp="vw0cmqfi09el" />
            <span className="text-ink-500" data-id="element-75" data-mp="ruoic7loj002">
              Monthly{' '}
              <span className="font-medium tabular-nums text-ink-900" data-id="element-76" data-mp="1ojw3heidz73g">
                {formatCurrency(totalMonthly)}
              </span>
            </span>
          </div> : <p className="inline-flex items-center gap-2 text-sm text-ink-500" data-id="element-77" data-mp="1jj8gd3xa3aei">
            <CheckCircle2Icon className="h-4 w-4 text-green-700" aria-hidden="true" data-id="element-78" data-mp="1fhmwgymbtvut" />
            All liabilities from this report are in Encompass.
          </p>}

        <button type="button" onClick={onPush} disabled={!hasPending || isPushing} className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-md bg-brand-500 px-5 text-sm font-semibold text-white transition-colors hover:bg-brand-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-ink-300" data-id="element-79" data-mp="41y6dyds0gps">
          {isPushing ? <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-80" data-mp="3rr3k1juks5rl" /> : <UploadCloudIcon className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="3dzoz37h3xuhw" />}
          {isPushing ? 'Pushing…' : `Push all liabilities${hasPending ? ` (${count})` : ''}`}
        </button>
      </div>
    </div>;
}